// extracted by mini-css-extract-plugin
export default {"helpIcon":"DiscountIcon_helpIcon__qP-Ke"};